struct Params_std140_0
{
    @align(16) worldSize_0 : vec2<f32>,
    @align(8) viewSize_0 : vec2<f32>,
    @align(16) gridSize_0 : vec2<f32>,
    @align(8) dotSize_0 : vec2<f32>,
    @align(16) fieldUvScale_0 : vec2<f32>,
    @align(8) pointer_0 : vec2<f32>,
    @align(16) pointerRadius_0 : f32,
    @align(4) pointerForce_0 : f32,
    @align(8) particleCount_0 : f32,
    @align(4) binCount_0 : f32,
    @align(16) binSize_0 : f32,
    @align(4) returnForce_0 : f32,
    @align(8) returnDamping_0 : f32,
    @align(4) dt_0 : f32,
    @align(16) mu_k_0 : f32,
    @align(4) sigma_k_0 : f32,
    @align(8) w_k_0 : f32,
    @align(4) mu_g_0 : f32,
    @align(16) sigma_g_0 : f32,
    @align(4) c_rep_0 : f32,
    @align(8) r_rep_0 : f32,
    @align(4) resetAttempts_0 : f32,
    @align(16) initialFieldScattering_0 : f32,
};

@binding(0) @group(0) var<uniform> data_params_0 : Params_std140_0;
struct Particle_std430_0
{
    @align(8) position_0 : vec2<f32>,
    @align(8) velocity_0 : vec2<f32>,
    @align(8) home_0 : vec2<f32>,
    @align(8) frame_0 : u32,
    @align(4) _pad_0 : u32,
};

@binding(1) @group(0) var<storage, read> data_source_0 : array<Particle_std430_0>;

@binding(2) @group(0) var<storage, read_write> data_destination_0 : array<Particle_std430_0>;

@binding(3) @group(0) var<storage, read> data_binOffsets_0 : array<u32>;

struct Frame_std430_0
{
    @align(8) origin_0 : vec2<f32>,
    @align(8) scale_0 : vec2<f32>,
};

@binding(4) @group(0) var<storage, read> data_frames_0 : array<Frame_std430_0>;

fn rsqrt_0( x_0 : f32) -> f32
{
    return 1.0f / sqrt(x_0);
}

fn peak_f_0( x_1 : f32,  mu_0 : f32,  sigma_0 : f32) -> vec2<f32>
{
    var t_0 : f32 = (x_1 - mu_0) / sigma_0;
    var y_0 : f32 = exp(- t_0 * t_0);
    return vec2<f32>(y_0, -2.0f * t_0 * y_0 / sigma_0);
}

struct Particle_0
{
     position_0 : vec2<f32>,
     velocity_0 : vec2<f32>,
     home_0 : vec2<f32>,
     frame_0 : u32,
     _pad_0 : u32,
};

@compute
@workgroup_size(64, 1, 1)
fn step(@builtin(global_invocation_id) gid_0 : vec3<u32>)
{
    var _S1 : u32 = gid_0.x;
    if(f32(_S1) >= (data_params_0.particleCount_0))
    {
        return;
    }
    var _S2 : Particle_std430_0 = data_source_0[_S1];
    var particle_0 : Particle_0;
    particle_0.position_0 = _S2.position_0;
    particle_0.velocity_0 = _S2.velocity_0;
    particle_0.home_0 = _S2.home_0;
    particle_0.frame_0 = _S2.frame_0;
    particle_0._pad_0 = _S2._pad_0;
    const _S3 : vec2<f32> = vec2<f32>(0.0f, 0.0f);
    var _S4 : f32 = peak_f_0(0.0f, data_params_0.mu_k_0, data_params_0.sigma_k_0).x * data_params_0.w_k_0;
    var gridX_0 : i32 = i32(data_params_0.gridSize_0.x);
    var gridY_0 : i32 = i32(data_params_0.gridSize_0.y);
    var _S5 : vec2<f32> = vec2<f32>(0.5f);
    var binF_0 : vec2<f32> = floor((particle_0.position_0 + _S5 * data_params_0.worldSize_0) / vec2<f32>(data_params_0.binSize_0));
    var _S6 : i32 = gridX_0 - i32(1);
    var binX_0 : i32 = i32(clamp(binF_0.x, 0.0f, f32(_S6)));
    var _S7 : i32 = gridY_0 - i32(1);
    var binY_0 : i32 = i32(clamp(binF_0.y, 0.0f, f32(_S7)));
    var _S8 : i32 = max(binY_0 - i32(1), i32(0));
    var _S9 : i32 = min(binX_0 + i32(1), _S6);
    var _S10 : i32 = min(binY_0 + i32(1), _S7);
    var x_2 : i32 = max(binX_0 - i32(1), i32(0));
    var R_grad_0 : vec2<f32> = _S3;
    var U_grad_0 : vec2<f32> = _S3;
    var U_0 : f32 = _S4;
    for(;;)
    {
        if(x_2 <= _S9)
        {
        }
        else
        {
            break;
        }
        var y_1 : i32 = _S8;
        for(;;)
        {
            if(y_1 <= _S10)
            {
            }
            else
            {
                break;
            }
            var realBinX_0 : i32 = (x_2 + gridX_0) % gridX_0;
            var realBinY_0 : i32 = (y_1 + gridY_0) % gridY_0;
            var binIndex_0 : u32 = u32(realBinY_0 * gridX_0 + realBinX_0);
            var _S11 : u32 = data_binOffsets_0[binIndex_0 + u32(1)];
            var j_0 : u32 = data_binOffsets_0[binIndex_0];
            var R_grad_1 : vec2<f32> = R_grad_0;
            var U_grad_1 : vec2<f32> = U_grad_0;
            var U_1 : f32 = U_0;
            for(;;)
            {
                if(j_0 < _S11)
                {
                }
                else
                {
                    break;
                }
                if(j_0 == _S1)
                {
                    j_0 = j_0 + u32(1);
                    continue;
                }
                var dp_0 : vec2<f32> = particle_0.position_0 - data_source_0[j_0].position_0;
                var r_0 : f32 = length(dp_0);
                var dhat_0 : vec2<f32> = dp_0 / vec2<f32>(max(r_0, 9.99999993922529029e-09f));
                var R_grad_2 : vec2<f32>;
                if(r_0 < (data_params_0.r_rep_0))
                {
                    R_grad_2 = R_grad_1 - dhat_0 * vec2<f32>((data_params_0.r_rep_0 - r_0));
                }
                else
                {
                    R_grad_2 = R_grad_1;
                }
                var K_0 : vec2<f32> = peak_f_0(r_0, data_params_0.mu_k_0, data_params_0.sigma_k_0) * vec2<f32>(data_params_0.w_k_0);
                var U_grad_2 : vec2<f32> = U_grad_1 + vec2<f32>(K_0.y) * dhat_0;
                var U_2 : f32 = U_1 + K_0.x;
                R_grad_1 = R_grad_2;
                U_grad_1 = U_grad_2;
                U_1 = U_2;
                j_0 = j_0 + u32(1);
            }
            y_1 = y_1 + i32(1);
            R_grad_0 = R_grad_1;
            U_grad_0 = U_grad_1;
            U_0 = U_1;
        }
        x_2 = x_2 + i32(1);
    }
    var pointerD_0 : vec2<f32> = particle_0.position_0 - data_params_0.pointer_0;
    var pointerD2_0 : f32 = dot(pointerD_0, pointerD_0);
    var frame_1 : Frame_std430_0 = data_frames_0[particle_0.frame_0];
    var _S12 : vec2<f32> = particle_0.velocity_0 * _S5 + vec2<f32>(data_params_0.dt_0) * ((vec2<f32>(0) - R_grad_0) * vec2<f32>(data_params_0.c_rep_0) + vec2<f32>(peak_f_0(U_0, data_params_0.mu_g_0, data_params_0.sigma_g_0).y) * U_grad_0 + vec2<f32>((data_params_0.pointerForce_0 * exp(- pointerD2_0 / (data_params_0.pointerRadius_0 * data_params_0.pointerRadius_0)))) * (pointerD_0 * vec2<f32>(rsqrt_0(max(pointerD2_0, 9.99999997475242708e-07f)))) + ((frame_1.origin_0 + particle_0.home_0 * frame_1.scale_0 - particle_0.position_0) * vec2<f32>(data_params_0.returnForce_0) - particle_0.velocity_0 * vec2<f32>((data_params_0.returnDamping_0 * sqrt(max(data_params_0.returnForce_0, 0.0f))))));
    particle_0.velocity_0 = _S12;
    particle_0.position_0 = particle_0.position_0 + vec2<f32>(data_params_0.dt_0) * _S12;
    data_destination_0[_S1].position_0 = particle_0.position_0;
    data_destination_0[_S1].velocity_0 = particle_0.velocity_0;
    data_destination_0[_S1].home_0 = particle_0.home_0;
    data_destination_0[_S1].frame_0 = particle_0.frame_0;
    data_destination_0[_S1]._pad_0 = particle_0._pad_0;
    return;
}

